import React from 'react'
import PropTypes from 'prop-types'
import { ContainerStyle, ImageStyle } from './styled'
import { useTranslation } from 'react-i18next'
import { Grid } from '@mui/material'
import Typography from '@mui/material/Typography';
import { getEntityImageUrl } from '../../../../api/utils'

const EventHeader = ({event, disclaimer}) => {

  const { t } = useTranslation()
  const eventImage = getEntityImageUrl(event, 'https://www.thermaxglobal.com/wp-content/uploads/2020/05/image-not-found.jpg')
  const eventName = event?.name ? event?.name : ''

  return (
    <ContainerStyle>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={3}>
          <ImageStyle>
            <img
              src={eventImage}
              alt="Event Image"
              style={{ width: '100%', height: 'auto' }}
            />
          </ImageStyle>
        </Grid>
        <Grid item xs={9}>
          <Typography variant="body1" gutterBottom>
            {eventName}
          </Typography>
          <Typography gutterBottom style={{fontSize: 12}}>
            {disclaimer ? t('event.joinDisclaimer') : t('event.joinConfirm')}
          </Typography>
          
        </Grid>
        <Grid item xs={12}>
        
        </Grid>
      </Grid>
    </ContainerStyle>
  )
}

EventHeader.propTypes = {
  event: PropTypes.object,
  disclaimer: PropTypes.bool
}
EventHeader.defaultProps = {
  event: {},
  disclaimer: true
}

export default EventHeader
